import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-theme-setting",
  "use": "oc-theme-setting-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-theme-setting\"><path data-follow-fill=\"#6B7180\" fill=\"#6B7180\" d=\"M7.563 1.688h-5.75v6.75l.873-.001.001 7.876h12.626V8.436h.874v-6.75h-5.75v1.188c0 .81-.626 1.438-1.437 1.438-.81 0-1.438-.627-1.438-1.438V1.687Zm7.125 1.499v3.75h-.876v7.875H4.187l.001-7.874-.875-.001v-3.75h2.766l.004.034A2.913 2.913 0 0 0 9 5.812l.174-.004a2.91 2.91 0 0 0 2.744-2.587l.003-.034h2.767Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol